export enum ContractStatus {
    CREATED = 'CREATED',
    FINISHED = 'FINALIZED',
    FOR_SIGN = 'FOR SIGNING',
    PRODUCTIVE = 'PRODUCTIVE',
    REJECTED = 'REJECTED',
    SENT = 'SENT',
    CANCELED = 'CANCELED',
    PBC_REVIEW = 'PBC_REVIEW',
    OTHER = '',
}
